import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Box, Checkbox, Grid, IconButton, Typography } from '@mui/material';

import { CommonReasons } from '@modules/ContactManager/components/Header/interfaces';
import { StyledFormControlLabel, WorkflowReasonCard } from '@styles/ContactManager/WorkflowDetailsStyles';
import { HeaderWrapper } from '@styles/DealSheet/DealSheetStyles';
import { Loader } from '@shared/enhancers/withLoader';

interface IReasonsPopUpProps {
  reasons: CommonReasons[];
  handleCheckboxChange: (item: CommonReasons, checked: boolean) => void;
  onClose: () => void;
  loading: boolean;
}

export const ReasonsPopUp = ({ reasons, handleCheckboxChange, onClose, loading }: IReasonsPopUpProps) => {
  return (
    <>
      <HeaderWrapper>
        <Typography variant="h4">Reasons</Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseOutlinedIcon />
        </IconButton>
      </HeaderWrapper>
      {loading ?
        <Loader
          color="inherit"
          minHeight='auto'
        />
        : <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <WorkflowReasonCard>
            <Grid container>
              {reasons.map((item) => {
                return (
                  <Grid key={item.reasonId} item sm={6}>
                    <StyledFormControlLabel
                      name={item.label}
                      control={
                        <Checkbox
                          checked={!item.isResolved}
                          onChange={(_, checked) => handleCheckboxChange(item, checked)}
                        />
                      }
                      label={
                        <Typography sx={{ textDecoration: item.isResolved ? 'line-through' : 'none',fontWeight: item.isLcCondition?'bold':'regular' }}>
                          {item.label} {item.description ? `: ${item.description}` : ''}
                        </Typography>
                      }
                    />
                  </Grid>
                );
              })}
            </Grid>
          </WorkflowReasonCard>
        </Box>
      }
    </>
  );
};